import fieldDataClient from "../../api/digitalTwin/fieldDataClient";
import { call, put, takeLatest } from "redux-saga/effects";
import {
  fetchRastersFailure,
  fetchRastersStart,
  fetchRastersSuccess,
} from "../../store/features/digitalTwin/rastersSlice";

const RASTERS_URL = "/rasters/";
const SURVEYS_URL = "/surveys/";

const getLatestSurvey = async (field_id) => {
  try {
    const response = await fieldDataClient.get(SURVEYS_URL, {
      params: {
        field_id,
        order_by: "survey_timestamp",
        order_dir: "desc",
        limit: 1,
      },
    });

    return response.data?.data?.[0] || null;
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message;
    throw new Error(errorMessage);
  }
};

const getRastersByField = async (field_id) => {
  try {
    const response = await fieldDataClient.get(RASTERS_URL, {
      params: {
        field_id,
        limit: 100,
        order_by: "id",
        order_dir: "asc",
      },
    });

    return response.data;
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message;
    throw new Error(errorMessage);
  }
};

function* fetchRastersSaga(action) {
  try {
    const { field_id } = action.payload;
    const latestSurvey = yield call(getLatestSurvey, field_id);

    if (!latestSurvey?.id) {
      yield put(fetchRastersSuccess({
        data: [],
        count: 0,
        total: 0,
        limit: 100,
        offset: 0,
        field_id,
        latestSurvey: null,
      }));
      return;
    }

    const rastersData = yield call(getRastersByField, field_id);
    console.log("latest survey from fetch", latestSurvey);
    console.log("rastersData from field fetch", rastersData);
    yield put(fetchRastersSuccess({
      ...rastersData,
      field_id,
      latestSurvey,
    }));
  } catch (error) {
    yield put(fetchRastersFailure(error.message));
  }
}

export default function* rastersSaga() {
  yield takeLatest(fetchRastersStart.type, fetchRastersSaga);
}
